import { useMutation } from '@tanstack/react-query';
import { toast } from '@/lib/toast';
import { UI_STRINGS } from '@/lib/constants/ui-strings';
import { getApiErrorMessage } from '@/lib/utils/error.utils';
import { downloadBlob } from '@/lib/utils/download.utils';
import { downloadStartupProfilePdf } from '../api/startup-profile.api';

const S = UI_STRINGS.STARTUP_PROFILE;

/**
 * Exports the startup's branded profile as a PDF (MYN-78) and triggers the
 * browser download. `onSuccess`/`onError` live on this mutation definition,
 * not on the `.mutate()` call site, so the download and the failure toast
 * still fire even if the triggering component (the profile header card)
 * unmounts before the request settles.
 *
 * Failure is reported via toast, never inline: the trigger is a plain page
 * button, not an open dialog, so there is no open surface to host an inline
 * `role="alert"`.
 */
export function useStartupProfilePdf() {
  return useMutation({
    mutationFn: ({ entityId, companyName }: { entityId: string; companyName: string }) =>
      downloadStartupProfilePdf(entityId, companyName),
    onSuccess: ({ blob, filename }) => {
      downloadBlob(blob, filename);
    },
    onError: (error) => {
      toast.error(getApiErrorMessage(error, S.EXPORT_PDF_ERROR));
    },
  });
}
